import http from '../../services/httpService';

export const getSeverities = async () => await http.get('/open_severities/');
